import { computeColorStatusActive } from "./color-status-filter";
import { FilterStatus } from "./filters";
import { Range } from "./range-status-days";

/**
 * Shared logic for the "all filters" button badge (header map / header list).
 * The badge counts the number of ACTIVE FILTERS, not the number of selected
 * values: a filter with 12 checked devices counts as 1, exactly like the
 * sidenav that lists one line per filter.
 * The radio filters (torn / unknown) are excluded: they always hold a default
 * value, so counting them would keep the badge permanently non-empty.
 */
export interface ActiveFiltersState {
  containers?: Array<string | number>;
  containerCategory?: Array<string | number>;
  incidents?: Array<string | number | Number>;
  lastSites?: Array<string | number>;
  devices?: Array<string | number>;
  confidenceRadius?: Array<string | number>;
  devicesTypes?: Array<string | number>;
  statusDays?: Range;
  colorStatus?: FilterStatus[];
  // Which colorStatus flag is the "shown" one ("show" in the headers,
  // "showDetail" in the detail views).
  colorStatusShowType?: string;
}

// A range filter is active as soon as one of its bounds is set (applying it
// auto-fills the missing bound, see FilterButtonComponent.applyRange).
function isRangeActive(range?: Range): boolean {
  return range?.start !== undefined || range?.end !== undefined;
}

export function countActiveFilters(state: ActiveFiltersState): number {
  const lists: Array<Array<unknown> | undefined> = [
    state.containers,
    state.containerCategory,
    state.incidents,
    state.lastSites,
    state.devices,
    state.confidenceRadius,
    state.devicesTypes
  ];

  let count: number = lists.filter((list) => (list?.length ?? 0) > 0).length;

  if (isRangeActive(state.statusDays)) count++;

  // "all selected" and "none selected" both mean "no filter" for colorStatus.
  const { activeData } = computeColorStatusActive(
    state.colorStatus,
    state.colorStatusShowType ?? "show"
  );
  if (activeData > 0) count++;

  return count;
}
